import { Link } from 'react-router-dom';
import { categories } from '@/mocks/manga';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-book-open-line text-background-50 text-lg"></i>
              </div>
              <span className="text-lg font-bold text-background-50 font-heading">
                韩漫漫画网
              </span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">
              韩漫在线阅读的首选平台，提供免费的韩国漫画和无删减下拉式韩漫大全，让您畅享原汁原味的阅读体验。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速链接</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-background-400 hover:text-primary-400 transition-colors">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category/all" className="text-sm text-background-400 hover:text-primary-400 transition-colors">
                  分类浏览
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">热门分类</h4>
            <ul className="space-y-2">
              {categories.slice(0, 6).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors"
                  >
                    {cat.name}韩漫
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">关于我们</h4>
            <p className="text-sm text-background-400 leading-relaxed mb-4">
              韩漫漫画网致力于为华语读者提供最优质的韩国漫画在线阅读服务。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-600 hover:text-background-50 transition-all" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-600 hover:text-background-50 transition-all" aria-label="QQ">
                <i className="ri-qq-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-600 hover:text-background-50 transition-all" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 韩漫漫画网 - 韩漫在线阅读 | 免费的韩国漫画 | 无删减下拉式韩漫大全
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors">
              隐私政策
            </a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors">
              服务条款
            </a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors">
              联系我们
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}